import Vue from 'vue'
import VueI18n from 'vue-i18n'
const constants = require('@/util/constants')

Vue.use(VueI18n)

// FIXME: 此种方式导致不能存储设置语言，下次进入时使用？
function loadLocaleInfo() {
  const locales = require.context('./locales', true, /(^|\/)[A-Za-z0-9_,\s-]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9_-]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return { messages }
}

const { messages } = loadLocaleInfo()

// let local = localStorage.i18n == null ? 'zh' : localStorage.i18n
// console.log('local:' + local)
const i18n = new VueI18n({
  locale: constants.I18N_DEFAULT_LOCAL,
  fallbackLocale: constants.I18N_DEFAULT_LOCAL,
  silentFallbackWarn: true,
  // formatFallbackMessages: true,
  messages
})

// if (module.hot) {
//   module.hot.accept(id, () => {
//     const { messages } = loadLocaleInfo()
//     Object.keys(messages).forEach(locale => {
//       i18n.setLocaleMessage(locale, messages[locale])
//     })
//     // console.log('hot module replacemenet', arguments)
//   })
// }

export default i18n
